
const Error404 = () => {
    return (
        <div className="container my-5 bg-dark">
            <div className="row">
                <div className="col-md-12">
                    <img src="https://www.techquintal.com/wp-content/uploads/2017/03/Fix-Error-404.jpg" alt="404" className="img-fluid"/>
                </div>
            </div>
        </div>
    )
}
export default Error404;